<template>
  <div>
    <div class="head" style="background-color: #f33737;text-align: center;color: #ffffff;line-height: 45px;">
      <img class="back" src="https://zhulong-lib.oss-cn-beijing.aliyuncs.com/img/eval/images/back.png" alt="" @click="back">
      <span style="font-size: 16px;">霍兰德职业兴趣测试</span>
    </div>
    <div class="title">
        <img src="https://zhulong-lib.oss-cn-beijing.aliyuncs.com/img/eval/images/title.png" alt="">
    </div>
    <div class="wen">
      <img src="https://zhulong-lib.oss-cn-beijing.aliyuncs.com/img/eval/images/wen.png" alt="">
    </div>
    <div class="text">
      <p>
          “霍兰德职业兴趣测试”也被称为自我指导探索测试，由美国著名职业指导专家约翰·霍兰德编制。霍兰德是美国约翰·霍普金斯大学心理学教授,他认为人的人格类型、兴趣与职业密切相关，兴趣是人们活动的巨大动力，凡具有职业兴趣的职业，都可以提高人们愉快从事该职业的积极性。
      </p>
      <p>
          霍兰德对职业兴趣类型进行了长期研究，于1959年提出了具有广泛社会影响的职业兴趣理论。根据霍兰德的理论，个体的职业兴趣可以影响其对职业的满意程度，当个体从事的职业与他的职业兴趣类型匹配时，个体的潜能将得到最大的释放，其在工作中将有更好的表现，获得更高的职业成就感。
      </p>
      <p class="three_p">
          在职业兴趣测试的帮助下，个体可以清晰地了解自己的职业兴趣类型，尤其是对于学生而言，可以帮助做好职业选择，从而在纷繁的职业机会中找到最适合自己的职业，避免盲目的选择。
      </p>
    </div>
    <div class="timu">
      <p class="timu_p1">
        本测试共有72道；题量较多，需时约5-10分钟。
      </p>
      <p class="timu_p2">
        测试前请仔细阅读下方的指导语：
      </p>
      <p class="timu_p3">
        1 . 本测试选项没有好坏之分，根据您的真实情况做出选择
      </p>
      <p class="timu_p4">
        2 . 请您根据第一印象，结合自身情况回答每一题。
      </p>
      <p class="timu_p5">
        新精英生涯提供专业内容及技术支持
      </p>
    </div>
    <div class="go_report" v-if="has_finish">
      <span @click="toReport">查看已完成报告 &gt;&gt;</span>
    </div>
    <div class="sub_btn" @click="toStart">
        开始测评
    </div>
  </div>
</template>
<script>
import { homeStart } from "@/api/interview";
export default {
  data(){
    return {
      resume_id: this.$route.query.resume_id,
      has_doing: 0, // 1 有正在做的题 0没有
      has_finish: 0,
      user_paper_id: ''
    }
  },
  created(){
    this.homeStart()
  },
  mounted(){
    
  },
  methods:{
    homeStart(){
      homeStart({resume_id: this.resume_id}).then(res=>{
        console.log(res,'res')
        if(res.errNo === 0){
          this.has_doing = res.result.has_doing
          this.has_finish = res.result.has_finish
          this.user_paper_id = res.result.user_paper_id
          if(this.has_doing == 1){
            this.initialize()
          }
        }
      })
    },
    initialize(){
      this.$dialog.confirm({
      title: "提示",
      confirmButtonText: '重新开始',
      confirmButtonColor: '#333',
      cancelButtonText: '继续做题',
      message: '您有尚未完成的测评，继续进行测评，还是重新开始？',
    })
      .then(() => {
        this.$router.push({
          path: 'start',
          query:{
            resume_id: this.resume_id
          }
        })
      })
      .catch(() => {
        this.$router.push({
          path: 'start',
          query:{
            user_paper_id: this.user_paper_id,
            resume_id: this.resume_id
          }
        })
      });
    },
    toStart(){
      this.$router.push({
        path: 'start',
        query:{
          resume_id: this.resume_id
        }
      })
    },
    toReport(){
      this.$router.push({
        path: 'report',
        query:{
          resume_id: this.resume_id
        }
      })
    },
    back(){
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.head{
  height: 88px;
  width: 100%;
  position: relative;
  .topimg{
    width: 100%;
    height: 100px;
  }
  .back{
    width: 22px;
    height: 36px;
    position: absolute;
    top: 24px;
    left: 5%;
  }
}
.title{
  height: 30px;
  margin: 0 4%;
  width: 92%;
  line-height: 30px;
  margin-top: 70px;
  margin-bottom: 30px;
  img{
  width: 50%;
  height: 30px
  }
}
.wen{
  margin: 0 4%;
  width: 92%;
  height: 342px;
  margin-bottom: 60px;
  img{
    width: 100%;
    width: 644px;
  }
}
.text{
  width: 92%;
  margin: 0 4%;
  font-size: 24px;
  line-height: 50px;
}
.text p{
  text-indent: 52px;
  color: #666;
}
.timu{
  width: 92%;
  margin: 0 4%;
  .timu_p1{
    margin-top: 70px;
    margin-bottom: 50px;
    font-size: 28px;
    font-weight: bolder;
    color: #333;
  }
}
.timu_p2{
  font-size: 28px;
  font-weight: bolder;
  margin-bottom: 38px;
}
.timu_p3,.timu_p4{
  font-size: 25px;
  line-height: 60px;
  color: #666;
}
.timu_p5{
  font-size: 28px;
  font-weight: bolder;
  margin-top: 38px;
}
.go_report{
  text-align: center;
  font-size: 24px;
  margin-top: 20px;
}
.sub_btn{
  width: 92%;
  border-radius: 46px;
  height: 84px;
  margin: 80px 4% 80px;
  background: url(https://zhulong-lib.oss-cn-beijing.aliyuncs.com/img/eval/images/click_btn.png) no-repeat ;
  background-size: 100%;
  font-size: 34px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 84px;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
}
</style>
